// extracted by mini-css-extract-plugin
export default {"routs":"Layout_routs__85v0F"};